import { styled } from '@mui/material';

const StyledColumn = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '1rem',
});

export default StyledColumn;
